import * as React from 'react';

import classNames from 'classnames';

import { Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';
import ContentGateContent from 'bundles/video-logged-out-page/components/content-gates/ContentGateContent';

import _t from 'i18n!nls/video-logged-out-page';

type Props = {
  videoAllowance: number;
  toggleOverlay: () => void;
  showOverlay: boolean;
};

const ContentGateFullPage = ({ videoAllowance, toggleOverlay, showOverlay }: Props) => {
  const gateOverlayClasses = classNames('vlp-gate-overlay');

  if (!showOverlay) return <div />;

  return (
    <div className={gateOverlayClasses}>
      <TrackedButton
        trackingName="content_gate_outside_modal_close"
        className="vlp-gate-overlay-close"
        onClick={toggleOverlay}
      />
      <section className="vlp-gate-overlay-content">
        <div className="vlp-gate-overlay-column-one">
          <ContentGateContent videoAllowance={videoAllowance} dismissClick={toggleOverlay} inFullOverlay />
        </div>

        <div className="vlp-gate-overlay-column-two">
          <div>
            <Typography2 component="h3" color="invertBody" variant="subtitleMedium">
              {_t('Why Coursera?')}
            </Typography2>
            <ul className="vlp-gate-overlay-list">
              <Typography2 component="li" color="invertBody" variant="bodyPrimary">
                {_t('100% online courses from top educators')}
              </Typography2>
              <Typography2 component="li" color="invertBody" variant="bodyPrimary">
                {_t('Support from instructors, mentors, and other learners')}
              </Typography2>
              <Typography2 component="li" color="invertBody" variant="bodyPrimary">
                {_t('Learn anytime via the web or mobile app')}
              </Typography2>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContentGateFullPage;
